<template>
  <div
    :class="teamHeaderSectionContainerClasses"
    @click="selectTeam(props.team.teamId || props.team.id)"
    :e2e-id="`${teamQualifier}Id`"
    :team-id="props.team.teamId || props.team.id"
  >
    <div :class="themeClassses.wrapper">
      <img v-if="props.team.logo" :class="themeClassses.image" :src="props.team.logo" alt="team" />
      <fallback-logo v-else :text="props.team.shortName" size="full" />
    </div>

    <div class="szw-flex szw-flex-col szw-max-w-35" :style="{ width: `${!isSmallWidgetContainerSize ? 'calc(100% - 56px)' : '100%'}` }">
      <span class="szw-font-semibold szw-text-sm szw-text-center szw-leading-[20px]">{{
        props.isSmallWidgetContainerSize ? props.team.shortName : localizeTeamName(props.team.teamId || props.team.id, props.team.name, langId)
      }}</span>
      <span v-if="props.mode !== 'banner' && props.mode !== 'no-underline'" class="szw-h-1 szw-w-full szw-rounded szw-mt-1" :class="selectedTeamClass" />
    </div>
  </div>
</template>
<script setup>
import FallbackLogo from '@/__core__/components/FallbackLogo.vue'
import { computed, inject } from 'vue'
import { localizeTeamName } from '@/__core__/localization/localization'

/**
 * @type {{
 *  direction: 'reversed' | 'base',
 *  team: { shortName: string, name: string, logo: string },
 *  isSmallWidgetContainerSize: boolean
 * }} props */
const props = defineProps({
  team: {
    type: Object,
    default: () => ({})
  },
  isSmallWidgetContainerSize: {
    type: Boolean,
    default: false
  },
  direction: {
    type: String,
    default: 'base',
    validator: value => ['base', 'reversed'].includes(value)
  },
  mode: {
    type: String,
    default: 'regular'
  },
  teamQualifier: {
    type: String,
    default: ''
  }
})

const selectedTeamId = inject('selectedTeamId', /* defaultValue */ null)
const langId = inject('langId', '')
const theme = inject('theme', '')

const themeClassses = computed(() => {
  if (theme && theme.value === 'euroleague') {
    return {
      wrapper: 'szw-min-h-[42px] szw-h-[42px] szw-w-[42px] szw-bg-background szw-rounded-full szw-flex szw-justify-center szw-items-center',
      image: 'szw-min-h-[30px] szw-h-[30px] szw-w-[30px] szw-m-auto'
    }
  } else {
    return {
      wrapper: 'szw-h-10 szw-w-10',
      image: 'szw-h-full szw-w-full'
    }
  }
})

const baseClasses = ['szw-flex szw-items-center ', { 'szw-cursor-pointer': selectedTeamId && selectedTeamId.value }]
const teamHeaderSectionContainerClasses = computed(() =>
  props.isSmallWidgetContainerSize
    ? [...baseClasses, 'szw-w-18.5 szw-flex-col szw-gap-[4px]']
    : [...baseClasses, 'szw-w-52.125 szw-uppercase szw-gap-4', props.direction === 'reversed' ? 'szw-flex-row-reverse' : 'szw-flex-row']
)
const selectTeam = id => {
  if (selectedTeamId && id) {
    selectedTeamId.value = id
  }
}
const selectedTeamClass = computed(() => {
  return selectedTeamId && selectedTeamId.value === (props.team.teamId || props.team.id) ? 'szw-bg-color-accent' : 'szw-bg-color-disable'
})
</script>
